import React from 'react';
import centredForm from '../components/centredForm';
import TermsAndConditions from '../../forms/TermsAndConditions';
import FormTitle from '../components/FormTitle';

export default centredForm(
  TermsAndConditions,
  <FormTitle title="termsAndConditions" />
);



// WEBPACK FOOTER //
// ./src/view/scenes/TermsAndConditions/index.js